
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnLaborGrid extends Serenity.EntityGrid<CertificationReturnLaborRow, any> {
        protected getColumnsKey() { return 'Invetory.CertificationReturnLabor'; }
        protected getDialogType() { return CertificationReturnLaborDialog; }
        protected getIdProperty() { return CertificationReturnLaborRow.idProperty; }
        protected getInsertPermission() { return CertificationReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationReturnLaborRow.localTextPrefix; }
        protected getService() { return CertificationReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}